export const SNACK_SET = 'SNACK_SET';
export const GET_SESSION_REQUEST = 'GET_SESSION_REQUEST';
export const GET_SESSION_SUCCESS = 'GET_SESSION_SUCCESS';
export const GET_SESSION_FAILURE = 'GET_SESSION_FAILURE';
export const GET_LOGS_FAILURE = 'GET_LOGS_FAILURE';
export const GET_LOGS_REQUEST = 'GET_LOGS_REQUEST';
export const GET_LOGS_SUCCESS = 'GET_LOGS_SUCCESS';
export const GET_LOG_PAYLOAD_FAILURE = 'GET_LOG_PAYLOAD_FAILURE';
export const GET_LOG_PAYLOAD_REQUEST = 'GET_LOG_PAYLOAD_REQUEST';
export const GET_LOG_PAYLOAD_SUCCESS = 'GET_LOG_PAYLOAD_SUCCESS';
export const GET_USERS_FAILURE = 'GET_USERS_FAILURE';
export const GET_USERS_REQUEST = 'GET_USERS_REQUEST';
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS';
export const GET_USER_MESSAGES_FAILURE = 'GET_USER_MESSAGES_FAILURE';
export const GET_USER_MESSAGES_REQUEST = 'GET_USER_MESSAGES_REQUEST';
export const GET_USER_MESSAGES_SUCCESS = 'GET_USER_MESSAGES_SUCCESS';
export const SEND_CUSTOM_MESSAGE_FAILURE = 'SEND_CUSTOM_MESSAGE_FAILURE';
export const SEND_CUSTOM_MESSAGE_REQUEST = 'SEND_CUSTOM_MESSAGE_REQUEST';
export const SEND_CUSTOM_MESSAGE_SUCCESS = 'SEND_CUSTOM_MESSAGE_SUCCESS';
export const GET_RESPUESTAS_FAILURE = 'GET_RESPUESTAS_FAILURE';
export const GET_RESPUESTAS_REQUEST = 'GET_RESPUESTAS_REQUEST';
export const GET_RESPUESTAS_SUCCESS = 'GET_RESPUESTAS_SUCCESS';
export const GET_MASIVOS_FAILURE = 'GET_MASIVOS_FAILURE';
export const GET_MASIVOS_REQUEST = 'GET_MASIVOS_REQUEST';
export const GET_MASIVOS_SUCCESS = 'GET_MASIVOS_SUCCESS';
export const USER_PROFILE_AVAILABLE = 'USER_PROFILE_AVAILABLE';
export const USER_PROFILE_REQUEST = 'USER_PROFILE_REQUEST';
export const USER_PROFILE_UNAVAILABLE = 'USER_PROFILE_UNAVAILABLE';
export const USER_ROLES_AVAILABLE = 'USER_ROLES_AVAILABLE';
export const USER_ROLES_REQUEST = 'USER_ROLES_REQUEST';
export const USER_ROLES_UNAVAILABLE = 'USER_ROLES_UNAVAILABLE';
export const GET_TEMPLATES_FAILURE = 'GET_TEMPLATES_FAILURE';
export const GET_TEMPLATES_REQUEST = 'GET_TEMPLATES_REQUEST';
export const GET_TEMPLATES_SUCCESS = 'GET_TEMPLATES_SUCCESS';
export const SET_PROFILE = 'SET_PROFILE';

// JWT Authentication
export const USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST';
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const USER_LOGIN_FAILURE = 'USER_LOGIN_FAILURE';
export const USER_LOGOUT = 'USER_LOGOUT';
export const TOKEN_REFRESH_REQUEST = 'TOKEN_REFRESH_REQUEST';
export const TOKEN_REFRESH_SUCCESS = 'TOKEN_REFRESH_SUCCESS';
export const TOKEN_REFRESH_FAILURE = 'TOKEN_REFRESH_FAILURE';

// Tenant Users
export const GET_TENANT_USERS_REQUEST = 'GET_TENANT_USERS_REQUEST';
export const GET_TENANT_USERS_SUCCESS = 'GET_TENANT_USERS_SUCCESS';
export const GET_TENANT_USERS_FAILURE = 'GET_TENANT_USERS_FAILURE';

export const CREATE_TENANT_USER_REQUEST = 'CREATE_TENANT_USER_REQUEST';
export const CREATE_TENANT_USER_SUCCESS = 'CREATE_TENANT_USER_SUCCESS';
export const CREATE_TENANT_USER_FAILURE = 'CREATE_TENANT_USER_FAILURE';

export const UPDATE_TENANT_USER_REQUEST = 'UPDATE_TENANT_USER_REQUEST';
export const UPDATE_TENANT_USER_SUCCESS = 'UPDATE_TENANT_USER_SUCCESS';
export const UPDATE_TENANT_USER_FAILURE = 'UPDATE_TENANT_USER_FAILURE';

export const DELETE_TENANT_USER_REQUEST = 'DELETE_TENANT_USER_REQUEST';
export const DELETE_TENANT_USER_SUCCESS = 'DELETE_TENANT_USER_SUCCESS';
export const DELETE_TENANT_USER_FAILURE = 'DELETE_TENANT_USER_FAILURE';

// FAQ Dashboard Constants
export const GET_FAQ_DASHBOARD_SUMMARY_REQUEST = 'GET_FAQ_DASHBOARD_SUMMARY_REQUEST';
export const GET_FAQ_DASHBOARD_SUMMARY_SUCCESS = 'GET_FAQ_DASHBOARD_SUMMARY_SUCCESS';
export const GET_FAQ_DASHBOARD_SUMMARY_FAILURE = 'GET_FAQ_DASHBOARD_SUMMARY_FAILURE';

export const GET_FAQ_STATS_REQUEST = 'GET_FAQ_STATS_REQUEST';
export const GET_FAQ_STATS_SUCCESS = 'GET_FAQ_STATS_SUCCESS';
export const GET_FAQ_STATS_FAILURE = 'GET_FAQ_STATS_FAILURE';

export const UPDATE_FAQ_QUESTION_REQUEST = 'UPDATE_FAQ_QUESTION_REQUEST';
export const UPDATE_FAQ_QUESTION_SUCCESS = 'UPDATE_FAQ_QUESTION_SUCCESS';
export const UPDATE_FAQ_QUESTION_FAILURE = 'UPDATE_FAQ_QUESTION_FAILURE';

export const SET_FAQ_DAYS_FILTER = 'SET_FAQ_DAYS_FILTER';

// User profile update constants
export const USER_UPDATE_PROFILE_REQUEST = 'USER_UPDATE_PROFILE_REQUEST';
export const USER_UPDATE_PROFILE_SUCCESS = 'USER_UPDATE_PROFILE_SUCCESS';
export const USER_UPDATE_PROFILE_FAILURE = 'USER_UPDATE_PROFILE_FAILURE';

// Conversation
export const GET_CONVERSATION_REQUEST = 'GET_CONVERSATION_REQUEST';
export const GET_CONVERSATION_SUCCESS = 'GET_CONVERSATION_SUCCESS';
export const GET_CONVERSATION_FAILURE = 'GET_CONVERSATION_FAILURE';
export const UPDATE_CONVERSATION_REQUEST = 'UPDATE_CONVERSATION_REQUEST';
export const UPDATE_CONVERSATION_SUCCESS = 'UPDATE_CONVERSATION_SUCCESS';
export const UPDATE_CONVERSATION_FAILURE = 'UPDATE_CONVERSATION_FAILURE';